module.exports = __webpack_public_path__ + "static/media/slide-4.0cfbc2db.jpg";